import api from './api';

// Returns true for admin/sports/sporsuperadmin/99, false for regionalsports (personel)
export const isAdminUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const role = (user.userType || user.role || 'admin').toString().toLowerCase();
    return role === 'admin' || role === 'sports' || role === 'sporsuperadmin' || role === '99';
  } catch {
    return true;
  }
};


export const login = async (email, password, turnstileToken = null) => {
  try {
    const invalidCredentialsResponse = {
      isSuccess: false,
      resultMessage: 'E-posta/kullanıcı adı veya şifre hatalı.'
    };

    let response = await api.post('/api/Authentication/Login', {
      email,
      password,
      turnstileToken
    });

    if (response && response.isSuccess && response.data) {
      const userData = response.data;
      localStorage.setItem('token', userData.jwToken);
      localStorage.setItem('user', JSON.stringify({
        id: userData.id || userData.regionalUserId,
        nameSurname: userData.nameSurname,
        email: userData.email,
        phoneNumber: userData.phoneNumber || '',
        isVerified: userData.isVerified,
        userType: userData.userType || userData.role,
        role: userData.role || userData.userType,
        assignedMahalle: userData.assignedMahalle || null,
        libraryId: userData.libraryId || null,
        assignedRegions: userData.assignedRegions || []
      }));
      localStorage.setItem('isAuthenticated', 'true');
      return response;
    }

    return response || invalidCredentialsResponse;
  } catch (error) {
    if (error?.response?.status === 400 || error?.response?.status === 401) {
      return {
        isSuccess: false,
        resultMessage: error?.response?.data?.resultMessage || error?.response?.data?.message || 'E-posta/kullanıcı adı veya şifre hatalı.'
      };
    }

    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('isAuthenticated');
  window.location.href = '/login';
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const getUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const isAuthenticated = () => {
  return !!getToken();
};

export const getLibraryId = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user.libraryId || null;
  } catch {
    return null;
  }
};

export const isLibraryOnlyUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const role = (user.userType || '').toLowerCase().trim();
    const result = role === 'library' && !!user.libraryId;
    console.log('[DEBUG] isLibraryOnlyUser check:', { role, libraryId: user.libraryId, result });
    return result;
  } catch {
    return false;
  }
};

export const requestAdminPasswordReset = async (email) => {
  try {
    const response = await api.post('/api/Authentication/RequestPasswordReset', { email });
    return response;
  } catch (error) {
    throw error;
  }
};

export const resetAdminPassword = async (email, code, newPassword) => {
  try {
    const response = await api.post('/api/Authentication/ResetPassword', {
      email,
      code,
      newPassword
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const verifyAdminPasswordResetCode = async (email, code) => {
  try {
    const response = await api.post('/api/Authentication/VerifyPasswordResetCode', {
      email,
      code
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const closeAllSessions = async () => {
  try {
    const response = await api.post('/api/Authentication/LogoutAllSessions');
    return response;
  } catch (error) {
    throw error;
  }
};
